var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.6667,
    stroke: "black",
    strokeOpacity: 0.15,
    strokeWidth: 0.666667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65869 16.6746C8.4783 16.8705 8.25084 16.9685 7.97633 16.9685C7.71751 16.9685 7.49595 16.8744 7.31164 16.6863C7.12732 16.4981 7.03516 16.2747 7.03516 16.0161C7.03516 15.7573 7.12928 15.5378 7.31752 15.3575L10.6587 12.0062L7.31752 8.65492C7.12928 8.47462 7.03516 8.25512 7.03516 7.99642C7.03516 7.73772 7.12732 7.51822 7.31164 7.33792C7.49595 7.15761 7.71751 7.06746 7.97633 7.06746C8.243 7.06746 8.46261 7.16154 8.63516 7.34968L11.9881 10.6892L15.3764 7.33792C15.5645 7.14194 15.7802 7.04395 16.0234 7.04395C16.2822 7.04395 16.5037 7.13606 16.688 7.32028C16.8724 7.5045 16.9645 7.72596 16.9645 7.98466C16.9645 8.23552 16.8704 8.45502 16.6823 8.64316L13.3293 12.0062L16.6705 15.3457C16.8587 15.5339 16.9528 15.7573 16.9528 16.0161C16.9528 16.2747 16.8607 16.4981 16.6764 16.6863C16.492 16.8744 16.2705 16.9685 16.0116 16.9685C15.7528 16.9685 15.5293 16.8705 15.3411 16.6746L11.9881 13.335L8.65869 16.6746Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileClose);
export default __webpack_public_path__ + "static/media/mobile-close.f8dbc62944d4a3b5aa0dfcd312160893.svg";
export { ForwardRef as ReactComponent };